import { Instance } from 'mobx-state-tree';
import { VisitUnscheduledDtoModelBase } from './VisitUnscheduledDtoModel.base';

/* The TypeScript type of an instance of VisitUnscheduledDtoModel */
export interface VisitUnscheduledDtoModelType extends Instance<typeof VisitUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for VisitUnscheduledDtoModel */
export { selectFromVisitUnscheduledDto, visitUnscheduledDtoModelPrimitives, VisitUnscheduledDtoModelSelector } from './VisitUnscheduledDtoModel.base';

/**
 * VisitUnscheduledDtoModel
 */
export const VisitUnscheduledDtoModel = VisitUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
